import { Button, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import useModalbar from 'modules/Modalbar/useModalbar'
import PageContainerDesktop from 'components/PageContainer/layout/PageContainer.desktop'
import HeaderBack from 'components/Desktop/HeaderBack'
import ClientNeeds from 'components/Desktop/ClientNeeds'

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px'
  },
  rootDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',

    gap: 5,
    paddingBottom: 0
  },
  radioBox: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10
  },
  textFields: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    marginBottom: 20
  },
  creditPercent: {
    width: '100%'
  },
  textArea: {
    marginBottom: 20
  }
}))
const REQUIRED_FIELDS = [
  { key: 'gender', value: 'пол' },
  { key: 'budget', value: 'Бюджет покупки' },
  { key: 'approximateBuy', value: 'Срок покупки' },
  { key: 'paymentType', value: 'Тип покупки' },
  { key: 'carOwnership', value: 'Наличие автомобиля' }
]
const ClientNeedsModal = ({
  handleClose,
  isEdit = false,
  onSave = () => {}
}) => {
  const classes = useStyles()
  const {
    store: { commentsRSE, seoLoading, loading },
    funcs: { onChangeRse }
  } = useSelectionStore()

  const { callModalbar } = useModalbar()

  const checkAndSave = () => {
    const newErrors = REQUIRED_FIELDS.map(v => {
      return commentsRSE?.[v.key] !== null ? null : v.value
    }).filter(v => !!v)

    if (newErrors.length > 0) {
      return callModalbar(
        'Заполните следующие поля:',
        <ul>
          {newErrors.map(v => (
            <li>{v}</li>
          ))}
        </ul>,
        {
          btnText: 'Понятно'
        }
      )
    }

    onSave()
  }

  return (
    <PageContainerDesktop
      customHeader={
        <HeaderBack onClick={handleClose}>Потребности клиента</HeaderBack>
      }
    >
      <LoaderBackdrop loading={seoLoading || loading} />

      <div className={classes.rootDiv}>
        <ClientNeeds commentsRSE={commentsRSE} onChangeRse={onChangeRse} />

        <Button
          fullWidth
          color="primary"
          variant="contained"
          size="small"
          disabled={seoLoading || loading}
          onClick={checkAndSave}
        >
          {isEdit ? 'Сохранить' : 'Сохранить и начать подбор'}
        </Button>
      </div>
    </PageContainerDesktop>
  )
}

export default ClientNeedsModal
